module.exports = __webpack_public_path__ + "static/img/promptpay.7037601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promptpay.png
// module id = 149
// module chunks = 1 3